import React from 'react';
import { Trophy } from 'lucide-react';
import { useLeaderboard } from '../../hooks/useLeaderboard';
import LeaderboardTable from './leaderboard/LeaderboardTable';
import LeaderboardTabs from './leaderboard/LeaderboardTabs';

const RankingLeaderboard: React.FC = () => {
  const [selectedType, setSelectedType] = React.useState('favorite');
  const { leaderboard, isLoading, error } = useLeaderboard(selectedType);

  if (error) {
    return (
      <div className="text-center text-red-400 py-8">
        Failed to load leaderboard
      </div>
    );
  }

  return (
    <div className="card p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-brand/10 rounded-lg">
          <Trophy className="w-5 h-5 text-brand" />
        </div>
        <h2 className="text-xl font-semibold text-content-primary">
          Current Rankings
        </h2>
      </div>

      <LeaderboardTabs
        selectedType={selectedType}
        onSelect={setSelectedType}
      />

      <LeaderboardTable
        data={leaderboard}
        isLoading={isLoading}
      />
    </div>
  );
};

export default RankingLeaderboard;